// extracted by mini-css-extract-plugin
module.exports = {"desktop":"(min-width: 1024px)","container":"orgMembersPage_container__10bzR"};